import { render } from "./ticket2Detail.vue?vue&type=template&id=08431e12&scoped=true"
import script from "./ticket2Detail.vue?vue&type=script&lang=js"
export * from "./ticket2Detail.vue?vue&type=script&lang=js"

import "./ticket2Detail.vue?vue&type=style&index=0&id=08431e12&scoped=true&lang=css"
import "./ticket2Detail.vue?vue&type=style&index=1&id=08431e12&lang=css"

import exportComponent from "/home/runner/work/user-ui/user-ui/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08431e12"]])

export default __exports__